import { ChevronDown } from "lucide-react";
import React from "react";
import { twMerge } from "tailwind-merge";

type Props = {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  icon?: React.ReactNode;
  defaultOpen?: boolean;
  className?: string;
  children: React.ReactNode;
};

/**
 * Zero-JS collapsible card (native <details>) used to demote secondary
 * sections (neighborhoods, air quality) without removing them.
 */
const CollapsibleSection: React.FC<Props> = ({
  title,
  subtitle,
  icon,
  defaultOpen = false,
  className,
  children,
}) => {
  return (
    <details
      open={defaultOpen}
      className={twMerge(
        "group rounded-2xl border border-border bg-background",
        className,
      )}
    >
      <summary className="flex cursor-pointer select-none list-none flex-row items-center gap-3 px-4 py-4 sm:px-5 [&::-webkit-details-marker]:hidden">
        {icon && (
          <span className="flex size-9 min-w-9 items-center justify-center rounded-lg bg-muted text-muted-foreground">
            {icon}
          </span>
        )}
        <span className="flex min-w-0 flex-col">
          <h2 className="text-base font-semibold text-foreground sm:text-lg">
            {title}
          </h2>
          {subtitle && (
            <span className="hidden text-sm text-muted-foreground sm:block">
              {subtitle}
            </span>
          )}
        </span>
        <ChevronDown className="ml-auto size-5 min-w-5 text-muted-foreground transition-transform group-open:rotate-180" />
      </summary>
      <div className="px-4 pb-5 sm:px-5">{children}</div>
    </details>
  );
};

export default CollapsibleSection;
